module.exports = __webpack_public_path__ + "static/media/icon-toggle-cross.187d832a.svg";